import ParentSetPasswordForm from "./ParentSetPasswordForm";

const SchoolParentSetPassword = () => {
  return <ParentSetPasswordForm type="school_parent" />;
};

export default SchoolParentSetPassword;
